<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href="route_back">Группы устройств</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование группы</li>
        </ol>
    </nav>

    <div class="two-col-container">
        <div class="left-col">
            <div class="form-narrow">
                <div class="mb-4">
                    <label for="group-name" class="form-label">
                        Название группы <span class="color-red">*</span>
                    </label>
                    <input type="text" class="form-control" id="group-name" v-model="name" placeholder="Название">
                </div>

                <div class="mb-4">
                    <div class="form-label">Клиент <span class="color-red">*</span></div>
                    <v-select
                        v-model="client_id"
                        :items="clients"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <span>Данные не найдены</span>
                        </template>
                    </v-select>
                </div>

                <div class="mb-4">
                    <div class="form-label">Бренд <span class="color-red">*</span></div>
                    <v-select
                        v-model="brand_id"
                        :items="brands"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <span>Данные не найдены</span>
                        </template>
                    </v-select>
                </div>

                <!-- Селект для отображения выбранного в группе типа устройств -->
                <div class="mb-4">
                    <div class="form-label">Тип устройства</div>
                    <v-select
                        disabled
                        v-model="device_type"
                        :items="device_types"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <span>Данные не найдены</span>
                        </template>
                    </v-select>
                </div>

                <!-- Кнопка выбора стандартной группой -->
                <!-- <div class="mb-3">
                    <div class="mb-1 form-label">Выбрать стандартной группой (новые устройства будут добавляться в данную группу при инициализации)</div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="selectedDefault">
                    </div>
                </div> -->
            </div>

            <div class="mb-3">
                <div class="mb-4">
                    <div class="mb-4">
                        <select-back-searchable-element
                            v-if="client_id && brand_id"
                            @getItems="loadDevices"
                            @syncItems="syncDevices"
                            :loaded_items="devices_founded"
                            :picked_items="devicesForSelect"
                            :pages="devices_pages">
                        </select-back-searchable-element>
                    </div>
                </div>

                <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
                    <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="editGroup"/>
                    <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
                </div>
            </div>
        </div>

        <Transition name="fade">
            <div v-if="showSelectedDevices" class="right-col">
                <SelectedDevices
                    :devicesFounded="devices_founded"
                    v-model:addedDevicesIds="device_ids_new"
                    v-model:deviceIds="devicesForSelect"
                    @stateChange="handleSelectedDevicesState"
                />
            </div>
        </Transition>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import SelectBackSearchableElement from "../../../../elements/SelectBackSearchableElement.vue";
import Group from '../../../../models/Group';
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import SelectedDevices from "../../../../elements/SelectedDevices.vue";

export default {
    name: "GroupEditComponent",
    components: { SelectBackSearchableElement, Alert, ConfirmBtn, SelectedDevices },
    props: {
        route_back: String,
        route_update: String,
        route_get: String,
        route_devices_search: String,
        route_get_devices_types: String,
        group_id: {
            type: Number,
        },
    },
    data: function () {
        return {
            group: new Group({
                route_update: this.route_update,
                route_get: this.route_get,
                route_brand_search: this.route_brand_search,
                route_client_search: this.route_client_search,
                route_device_groups_search: this.route_device_groups_search,
                route_devices_search: this.route_devices_search
            }),
            clients: [],
            brands: [],
            devices: [],
            device_type: null,
            device_types: [],
            devices_founded: [],
            device_ids: [],
            devices_pages: 1,
            device_ids_new: [],
            devices_changed: false,
            client_id: null,
            brand_id: null,
            numberPharmacy: '',
            city: '',
            address: '',
            selectedClientId: null,
            selectedBrandId: null,
            selectedDevices: [],
            name: '',
            selectedDefault: false,
            isOpenDropDown: false,
            search: null,
            showSelectedDevices: false,
            devicesForSelect: []
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        getDevicesTypes: async function () {
            let data = await axios.get(this.route_get_devices_types, {
                params: {
                    limit: 9999
                }
            });
            this.device_types = data.data.items;
        },
        editGroup: async function () {
            if (this.name.trim() == '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название группы' });
                this.toggleLoading();
                return;
            }

            if (!this.client_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента' });
                this.toggleLoading();
                return;
            }

            if (!this.brand_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите бренд' });
                this.toggleLoading();
                return;
            }

            if (this.device_type == null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите тип устройства' });
                this.toggleLoading();
                return;
            }

            // Обязательность выбора устройств
            if (!this.devicesForSelect.length) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Добавьте хотя бы одно устройство' });
                return;
            }

            const result = await axios.post('/clients/device-groups/update', {
                id: this.group_id,
                client_id: this.client_id,
                brand_id: this.brand_id,
                device_ids: this.devicesForSelect.map(el => el.id),
                name: this.name,
                default: this.selectedDefault ? 1 : 0
            }).then(response => {
                return response.data.status != undefined && response.data.status == 'ok';
            });

            if(result) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось обновить группу что то пошло не так' });
                this.toggleLoading();
            }
        },
        syncDevices: function (devices) {
            this.devicesForSelect = devices;
            this.devices_changed = true;
        },
        loadDevices: async function (search, limit, page) {
            if (!this.client_id || !this.brand_id) {
                console.log('Выберите клиента и бренд для поиска устройств.');
                return;
            }

            let data = await this.group.devices({
                search: search,
                limit: limit,
                page: page,
                client_id: this.client_id,
                brand_id: this.brand_id,
                device_type_id: this.device_type
            });

            this.devices_founded = data.items;

            this.selectedDevices.forEach(device => {
                const found = this.devices_founded.find(el => el.id === device.id);
                if (found && !this.devicesForSelect.some(el => el.id === found.id)) {
                    this.devicesForSelect = [...this.devicesForSelect, found];
                }
            });
        },

        onChangeClient: async function() {
            this.selectedDevices = [];
            this.brand_id = null;
            await this.getBrands();
            if (this.client_id && this.brand_id && this.device_type) {
                await this.loadDevices();
            }
        },
        onChangeBrand: async function () {
            this.selectedDevices = [];
            if (this.client_id && this.brand_id && this.device_type) {
                await this.getDevices();
            }
        },
        getClients: async function () {
            const clients = await axios.get('/clients/device-groups/get/clients').then(response => {
                if(response.data.items !== undefined)
                {
                    if(response.data.items.length > 0)
                    {
                        return response.data.items;
                    }
                }
                return false;
            });

            if (clients) {
                this.clients = clients;
            }
        },
        getBrands: async function () {
            const brands = await axios.get('/clients/device-groups/get/brands', {params: {
                client_id: this.client_id
            }}).then(response => {
                if(response.data.items !== undefined)
                {
                    if(response.data.items.length > 0)
                    {
                        return response.data.items;
                    }
                }
                return false;
            });

            if (brands) {
                this.brands = brands;
            }
        },
        getDevices: async function () {
            const devices = await axios.get('/clients/device-groups/search/devices', {
                params: {
                    client_id: this.client_id,
                    brand_id: this.brand_id,
                    device_type_id: this.device_type,
                    search: this.search,
            }}).then(response => {
                if(response.data.items !== undefined)
                {
                    if(response.data.items.length > 0)
                    {
                        return response.data.items;
                    }
                }
                return false;
            });

            if (devices) {
                this.devices = devices;
            }
            
            if (!devices) {
                this.devices = []
            }
        },
        getGroup: async function() {
            const group = await axios.get('/clients/device-groups/get/group', {params: {
                id: this.group_id
            }}).then(response => {
                if(response.data.status === 'ok')
                {
                    return response.data.object;
                }
                return false;
            });

            if (!group) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Что-то пошло не так, не удалось обновить группу' });
            }

            if (group) {
                this.device_type = group.device_type_id
                this.name = group.name;
                this.selectedDefault = group.default;

                await this.getClients();
                this.client_id = group.client_id;

                await this.getBrands();
                this.brand_id = group.brand_id;

                this.selectedDevices = group.devices;

                await this.getDevices();
            }
        },
        handleSelectedDevicesState(state) {
            this.showSelectedDevices = state;
        }
    },
    watch: {
        devicesForSelect(val) {
            if (val.length) {
                this.showSelectedDevices = true;
            }
        }
    },
    mounted() {
        this.getGroup();
        this.getDevicesTypes();
    }
}
</script>

<style scoped>
    .app-dropdown {
        border-radius: 5px;
        position: relative;
    }

    .app-dropdown .manager {
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .app-dropdown .items-block {
        position: relative;
        height: 200px;
        overflow: auto;
        z-index: 9999;
        background-color: #fff;
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .app-dropdown .items-block .searching-block {
        position: sticky;
        top: 0;
        background-color: #fff;
    }

    .app-dropdown .items-block .searching-block input {
        border-bottom: 1px solid #ddd;
        border-top: none;
        border-radius: 0;
        border-left: none;
        border-right: none;
    }

    .app-dropdown .items {
        position: absolute;
        width: 100%;
    }

    .app-dropdown .items .item {
        padding: 0 10px;
        cursor: pointer;
        font-size: 16px;
    }

    .app-dropdown .items .item:hover {
        background-color: #3c7af0;
        color: white;
    }

    .app-dropdown .hidden {
        display: none;
    }

    .app-dropdown .manager {
        padding: 15px;
        height: 40px;
        cursor: pointer;
    }

    .app-dropdown .manager .button {
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
        background-repeat: no-repeat;
        background-position: center right;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 16px;
    }

    .app-dropdown .shade {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 999;
        min-height: 100vh;
        overflow: hidden;
    }

    .app-dropdown .content {
        position: absolute;
        width: 100%;
        height: 200px;
        top: -500%;
    }

    .app-dropdown .disable{
        background-color: #ddd;
        cursor: initial;
    }
</style>
